"use strict";
/* eslint-disable */
// tslint:disable
/**
 * Umbrella API
 * The API for the Umbrella webapp, including administration and user features.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: anton@cactuslab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortSurveys = exports.SortParticipants = exports.QuestionTypeEnum = exports.FilterSurveys = exports.FilterSurveyParticipants = exports.AdminUserRole = exports.Api = void 0;
var Api;
(function (Api) {
    /**
     * @export
     * @namespace AccountSurveysError
     */
    var AccountSurveysError;
    (function (AccountSurveysError) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["DuplicateName"] = "DuplicateName";
                CodeEnum["TemplateNotFound"] = "TemplateNotFound";
                CodeEnum["Validation"] = "Validation";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = AccountSurveysError.Message || (AccountSurveysError.Message = {}));
    })(AccountSurveysError = Api.AccountSurveysError || (Api.AccountSurveysError = {}));
    /**
     * @export
     * @namespace AddParticipants400Response
     */
    var AddParticipants400Response;
    (function (AddParticipants400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["SurveyLocked"] = "SurveyLocked";
                CodeEnum["Validation"] = "Validation";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = AddParticipants400Response.Message || (AddParticipants400Response.Message = {}));
    })(AddParticipants400Response = Api.AddParticipants400Response || (Api.AddParticipants400Response = {}));
    var AdminUserRole;
    (function (AdminUserRole) {
        AdminUserRole["Report"] = "report";
        AdminUserRole["View"] = "view";
        AdminUserRole["Edit"] = "edit";
        AdminUserRole["Manage"] = "manage";
    })(AdminUserRole = Api.AdminUserRole || (Api.AdminUserRole = {}));
    /**
     * @export
     * @namespace CloseSurvey400Response
     */
    var CloseSurvey400Response;
    (function (CloseSurvey400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["CantClose"] = "CantClose";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = CloseSurvey400Response.Message || (CloseSurvey400Response.Message = {}));
    })(CloseSurvey400Response = Api.CloseSurvey400Response || (Api.CloseSurvey400Response = {}));
    /**
     * @export
     * @namespace ConfirmTotp400Response
     */
    var ConfirmTotp400Response;
    (function (ConfirmTotp400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["InvalidToken"] = "InvalidToken";
                CodeEnum["InvalidTOTPCode"] = "InvalidTOTPCode";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = ConfirmTotp400Response.Message || (ConfirmTotp400Response.Message = {}));
    })(ConfirmTotp400Response = Api.ConfirmTotp400Response || (Api.ConfirmTotp400Response = {}));
    /**
     * @export
     * @namespace CreateAccount400Response
     */
    var CreateAccount400Response;
    (function (CreateAccount400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["Validation"] = "Validation";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = CreateAccount400Response.Message || (CreateAccount400Response.Message = {}));
    })(CreateAccount400Response = Api.CreateAccount400Response || (Api.CreateAccount400Response = {}));
    /**
     * @export
     * @namespace CreateCustomQuestion400Response
     */
    var CreateCustomQuestion400Response;
    (function (CreateCustomQuestion400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["SurveyLocked"] = "SurveyLocked";
                CodeEnum["SectionNotFound"] = "SectionNotFound";
                CodeEnum["QuestionAlreadyExists"] = "QuestionAlreadyExists";
                CodeEnum["UnsupportedQuestionType"] = "UnsupportedQuestionType";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = CreateCustomQuestion400Response.Message || (CreateCustomQuestion400Response.Message = {}));
    })(CreateCustomQuestion400Response = Api.CreateCustomQuestion400Response || (Api.CreateCustomQuestion400Response = {}));
    /**
     * @export
     * @namespace DeleteSurvey400Response
     */
    var DeleteSurvey400Response;
    (function (DeleteSurvey400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["SurveyLocked"] = "SurveyLocked";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = DeleteSurvey400Response.Message || (DeleteSurvey400Response.Message = {}));
    })(DeleteSurvey400Response = Api.DeleteSurvey400Response || (Api.DeleteSurvey400Response = {}));
    /**
     * @export
     * @namespace EmailLoginError
     */
    var EmailLoginError;
    (function (EmailLoginError) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["InvalidToken"] = "InvalidToken";
                CodeEnum["NewPasswordInvalid"] = "NewPasswordInvalid";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = EmailLoginError.Message || (EmailLoginError.Message = {}));
    })(EmailLoginError = Api.EmailLoginError || (Api.EmailLoginError = {}));
    var FilterSurveyParticipants;
    (function (FilterSurveyParticipants) {
        FilterSurveyParticipants["All"] = "all";
        FilterSurveyParticipants["Invited"] = "invited";
        FilterSurveyParticipants["NotInvited"] = "notInvited";
        FilterSurveyParticipants["Completed"] = "completed";
        FilterSurveyParticipants["NotCompleted"] = "notCompleted";
        FilterSurveyParticipants["HasEmailAddress"] = "hasEmailAddress";
    })(FilterSurveyParticipants = Api.FilterSurveyParticipants || (Api.FilterSurveyParticipants = {}));
    var FilterSurveys;
    (function (FilterSurveys) {
        FilterSurveys["Current"] = "current";
        FilterSurveys["Archived"] = "archived";
        FilterSurveys["All"] = "all";
        FilterSurveys["ReportAvailable"] = "reportAvailable";
    })(FilterSurveys = Api.FilterSurveys || (Api.FilterSurveys = {}));
    /**
     * @export
     * @namespace FreeTextQuestion
     */
    var FreeTextQuestion;
    (function (FreeTextQuestion) {
        var FreeTextTypeEnum;
        (function (FreeTextTypeEnum) {
            FreeTextTypeEnum["Short"] = "short";
            FreeTextTypeEnum["Long"] = "long";
        })(FreeTextTypeEnum = FreeTextQuestion.FreeTextTypeEnum || (FreeTextQuestion.FreeTextTypeEnum = {}));
    })(FreeTextQuestion = Api.FreeTextQuestion || (Api.FreeTextQuestion = {}));
    /**
     * @export
     * @namespace GetParticipationReport400Response
     */
    var GetParticipationReport400Response;
    (function (GetParticipationReport400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["ReportCannotBeGenerated"] = "ReportCannotBeGenerated";
                CodeEnum["NoReportAvailable"] = "NoReportAvailable";
                CodeEnum["SurveyNotComplete"] = "SurveyNotComplete";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = GetParticipationReport400Response.Message || (GetParticipationReport400Response.Message = {}));
    })(GetParticipationReport400Response = Api.GetParticipationReport400Response || (Api.GetParticipationReport400Response = {}));
    /**
     * @export
     * @namespace GetReport400Response
     */
    var GetReport400Response;
    (function (GetReport400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["OpenSurvey"] = "OpenSurvey";
                CodeEnum["InternalError"] = "InternalError";
                CodeEnum["CannotCompareSurveys"] = "CannotCompareSurveys";
                CodeEnum["SampleTooSmall"] = "SampleTooSmall";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = GetReport400Response.Message || (GetReport400Response.Message = {}));
    })(GetReport400Response = Api.GetReport400Response || (Api.GetReport400Response = {}));
    /**
     * @export
     * @namespace IndividualReport
     */
    var IndividualReport;
    (function (IndividualReport) {
        /**
         * @export
         * @namespace Section
         */
        var Section;
        (function (Section) {
            var LayoutEnum;
            (function (LayoutEnum) {
                LayoutEnum["Icons"] = "icons";
                LayoutEnum["Summary"] = "summary";
                LayoutEnum["Ranges"] = "ranges";
            })(LayoutEnum = Section.LayoutEnum || (Section.LayoutEnum = {}));
        })(Section = IndividualReport.Section || (IndividualReport.Section = {}));
    })(IndividualReport = Api.IndividualReport || (Api.IndividualReport = {}));
    /**
     * @export
     * @namespace MultichoiceQuestion
     */
    var MultichoiceQuestion;
    (function (MultichoiceQuestion) {
        var MultichoiceTypeEnum;
        (function (MultichoiceTypeEnum) {
            MultichoiceTypeEnum["Single"] = "single";
            MultichoiceTypeEnum["Multi"] = "multi";
            MultichoiceTypeEnum["LongSingle"] = "long-single";
        })(MultichoiceTypeEnum = MultichoiceQuestion.MultichoiceTypeEnum || (MultichoiceQuestion.MultichoiceTypeEnum = {}));
    })(MultichoiceQuestion = Api.MultichoiceQuestion || (Api.MultichoiceQuestion = {}));
    /**
     * @export
     * @namespace OpenSurvey400Response
     */
    var OpenSurvey400Response;
    (function (OpenSurvey400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["CantStart"] = "CantStart";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = OpenSurvey400Response.Message || (OpenSurvey400Response.Message = {}));
    })(OpenSurvey400Response = Api.OpenSurvey400Response || (Api.OpenSurvey400Response = {}));
    /**
     * @export
     * @namespace ParticipantGroup
     */
    var ParticipantGroup;
    (function (ParticipantGroup) {
        var GroupTypeEnum;
        (function (GroupTypeEnum) {
            GroupTypeEnum["Regular"] = "regular";
            GroupTypeEnum["AllParticipants"] = "allParticipants";
        })(GroupTypeEnum = ParticipantGroup.GroupTypeEnum || (ParticipantGroup.GroupTypeEnum = {}));
    })(ParticipantGroup = Api.ParticipantGroup || (Api.ParticipantGroup = {}));
    /**
     * @export
     * @namespace ParticipantGroupError
     */
    var ParticipantGroupError;
    (function (ParticipantGroupError) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["DuplicateName"] = "DuplicateName";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = ParticipantGroupError.Message || (ParticipantGroupError.Message = {}));
    })(ParticipantGroupError = Api.ParticipantGroupError || (Api.ParticipantGroupError = {}));
    /**
     * @export
     * @namespace Participation
     */
    var Participation;
    (function (Participation) {
        var StatusEnum;
        (function (StatusEnum) {
            StatusEnum["ADDED"] = "ADDED";
            StatusEnum["INVITED"] = "INVITED";
            StatusEnum["COMPLETED"] = "COMPLETED";
        })(StatusEnum = Participation.StatusEnum || (Participation.StatusEnum = {}));
    })(Participation = Api.Participation || (Api.Participation = {}));
    /**
     * @export
     * @namespace ParticipationAnswerError
     */
    var ParticipationAnswerError;
    (function (ParticipationAnswerError) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["ParticipationNotFound"] = "ParticipationNotFound";
                CodeEnum["ParticipationAlreadyCompleted"] = "ParticipationAlreadyCompleted";
                CodeEnum["QuestionNotFound"] = "QuestionNotFound";
                CodeEnum["StringValueNotAllowed"] = "StringValueNotAllowed";
                CodeEnum["IntValueOutOfBounds"] = "IntValueOutOfBounds";
                CodeEnum["NoAnswerProvided"] = "NoAnswerProvided";
                CodeEnum["SurveyNotAvailable"] = "SurveyNotAvailable";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = ParticipationAnswerError.Message || (ParticipationAnswerError.Message = {}));
    })(ParticipationAnswerError = Api.ParticipationAnswerError || (Api.ParticipationAnswerError = {}));
    /**
     * @export
     * @namespace ParticipationClaimError
     */
    var ParticipationClaimError;
    (function (ParticipationClaimError) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["ParticipationNotFound"] = "ParticipationNotFound";
                CodeEnum["ParticipationAlreadyRegistered"] = "ParticipationAlreadyRegistered";
                CodeEnum["InvalidToken"] = "InvalidToken";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = ParticipationClaimError.Message || (ParticipationClaimError.Message = {}));
    })(ParticipationClaimError = Api.ParticipationClaimError || (Api.ParticipationClaimError = {}));
    /**
     * @export
     * @namespace ParticipationCompletionError
     */
    var ParticipationCompletionError;
    (function (ParticipationCompletionError) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["ParticipationNotFound"] = "ParticipationNotFound";
                CodeEnum["UnAnsweredQuestion"] = "UnAnsweredQuestion";
                CodeEnum["ParticipationExpired"] = "ParticipationExpired";
                CodeEnum["ParticipationAlreadyCompleted"] = "ParticipationAlreadyCompleted";
                CodeEnum["SurveyNotAvailable"] = "SurveyNotAvailable";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = ParticipationCompletionError.Message || (ParticipationCompletionError.Message = {}));
    })(ParticipationCompletionError = Api.ParticipationCompletionError || (Api.ParticipationCompletionError = {}));
    /**
     * @export
     * @namespace ParticipationRegistrationError
     */
    var ParticipationRegistrationError;
    (function (ParticipationRegistrationError) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["ParticipationNotFound"] = "ParticipationNotFound";
                CodeEnum["InvalidCredentials"] = "InvalidCredentials";
                CodeEnum["NewPasswordInvalid"] = "NewPasswordInvalid";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = ParticipationRegistrationError.Message || (ParticipationRegistrationError.Message = {}));
    })(ParticipationRegistrationError = Api.ParticipationRegistrationError || (Api.ParticipationRegistrationError = {}));
    /**
     * @export
     * @namespace ParticipationRegistrationSuccess
     */
    var ParticipationRegistrationSuccess;
    (function (ParticipationRegistrationSuccess) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["ParticipationAlreadyRegistered"] = "ParticipationAlreadyRegistered";
                CodeEnum["RegisteredToExistingAccount"] = "RegisteredToExistingAccount";
                CodeEnum["RegisteredToNewAccount"] = "RegisteredToNewAccount";
                CodeEnum["RegistrationConfirmationEmailSent"] = "RegistrationConfirmationEmailSent";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = ParticipationRegistrationSuccess.Message || (ParticipationRegistrationSuccess.Message = {}));
    })(ParticipationRegistrationSuccess = Api.ParticipationRegistrationSuccess || (Api.ParticipationRegistrationSuccess = {}));
    /**
     * @export
     * @namespace ParticipationSurvey
     */
    var ParticipationSurvey;
    (function (ParticipationSurvey) {
        var StatusEnum;
        (function (StatusEnum) {
            StatusEnum["Pending"] = "pending";
            StatusEnum["Open"] = "open";
            StatusEnum["Closed"] = "closed";
        })(StatusEnum = ParticipationSurvey.StatusEnum || (ParticipationSurvey.StatusEnum = {}));
    })(ParticipationSurvey = Api.ParticipationSurvey || (Api.ParticipationSurvey = {}));
    /**
     * @export
     * @namespace PatchAccount400Response
     */
    var PatchAccount400Response;
    (function (PatchAccount400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["InvalidImage"] = "InvalidImage";
                CodeEnum["Validation"] = "Validation";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = PatchAccount400Response.Message || (PatchAccount400Response.Message = {}));
    })(PatchAccount400Response = Api.PatchAccount400Response || (Api.PatchAccount400Response = {}));
    /**
     * @export
     * @namespace PatchSurveyError
     */
    var PatchSurveyError;
    (function (PatchSurveyError) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["TemplateNotFound"] = "TemplateNotFound";
                CodeEnum["Validation"] = "Validation";
                CodeEnum["SurveyLocked"] = "SurveyLocked";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = PatchSurveyError.Message || (PatchSurveyError.Message = {}));
    })(PatchSurveyError = Api.PatchSurveyError || (Api.PatchSurveyError = {}));
    /**
     * @export
     * @namespace PersonDetails
     */
    var PersonDetails;
    (function (PersonDetails) {
        /**
         * @export
         * @namespace Membership
         */
        var Membership;
        (function (Membership) {
            var RoleEnum;
            (function (RoleEnum) {
                RoleEnum["Admin"] = "admin";
            })(RoleEnum = Membership.RoleEnum || (Membership.RoleEnum = {}));
        })(Membership = PersonDetails.Membership || (PersonDetails.Membership = {}));
    })(PersonDetails = Api.PersonDetails || (Api.PersonDetails = {}));
    /**
     * @export
     * @namespace PostReminders400Response
     */
    var PostReminders400Response;
    (function (PostReminders400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["EmailCouldNotBeSent"] = "EmailCouldNotBeSent";
                CodeEnum["SurveyNotOpen"] = "SurveyNotOpen";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = PostReminders400Response.Message || (PostReminders400Response.Message = {}));
    })(PostReminders400Response = Api.PostReminders400Response || (Api.PostReminders400Response = {}));
    /**
     * @export
     * @namespace PostResetPassword400Response
     */
    var PostResetPassword400Response;
    (function (PostResetPassword400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["InvalidToken"] = "InvalidToken";
                CodeEnum["NewPasswordInvalid"] = "NewPasswordInvalid";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = PostResetPassword400Response.Message || (PostResetPassword400Response.Message = {}));
    })(PostResetPassword400Response = Api.PostResetPassword400Response || (Api.PostResetPassword400Response = {}));
    /**
     * <p>determines question type, e.g. scale,</p>
     */
    var QuestionTypeEnum;
    (function (QuestionTypeEnum) {
        QuestionTypeEnum["Scale"] = "scale";
        QuestionTypeEnum["Multi"] = "multi";
        QuestionTypeEnum["Matrix"] = "matrix";
        QuestionTypeEnum["MatrixSub"] = "matrix-sub";
        QuestionTypeEnum["FreeText"] = "free-text";
        QuestionTypeEnum["SurveyQuestion"] = "SurveyQuestion";
    })(QuestionTypeEnum = Api.QuestionTypeEnum || (Api.QuestionTypeEnum = {}));
    /**
     * @export
     * @namespace RemoveParticipations400Response
     */
    var RemoveParticipations400Response;
    (function (RemoveParticipations400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["InvalidParticipant"] = "InvalidParticipant";
                CodeEnum["SurveyLocked"] = "SurveyLocked";
                CodeEnum["ParticipationCompleted"] = "ParticipationCompleted";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = RemoveParticipations400Response.Message || (RemoveParticipations400Response.Message = {}));
    })(RemoveParticipations400Response = Api.RemoveParticipations400Response || (Api.RemoveParticipations400Response = {}));
    /**
     * @export
     * @namespace RemoveQuestion400Response
     */
    var RemoveQuestion400Response;
    (function (RemoveQuestion400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["SurveyLocked"] = "SurveyLocked";
                CodeEnum["SectionNotFound"] = "SectionNotFound";
                CodeEnum["QuestionNotFound"] = "QuestionNotFound";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = RemoveQuestion400Response.Message || (RemoveQuestion400Response.Message = {}));
    })(RemoveQuestion400Response = Api.RemoveQuestion400Response || (Api.RemoveQuestion400Response = {}));
    /**
     * @export
     * @namespace ResendThanks400Response
     */
    var ResendThanks400Response;
    (function (ResendThanks400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["EmailCouldNotBeSent"] = "EmailCouldNotBeSent";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = ResendThanks400Response.Message || (ResendThanks400Response.Message = {}));
    })(ResendThanks400Response = Api.ResendThanks400Response || (Api.ResendThanks400Response = {}));
    /**
     * @export
     * @namespace ResetCustomSection400Response
     */
    var ResetCustomSection400Response;
    (function (ResetCustomSection400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["SurveyLocked"] = "SurveyLocked";
                CodeEnum["SectionNotFound"] = "SectionNotFound";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = ResetCustomSection400Response.Message || (ResetCustomSection400Response.Message = {}));
    })(ResetCustomSection400Response = Api.ResetCustomSection400Response || (Api.ResetCustomSection400Response = {}));
    /**
     * @export
     * @namespace SendReminders400Response
     */
    var SendReminders400Response;
    (function (SendReminders400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["CantSend"] = "CantSend";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = SendReminders400Response.Message || (SendReminders400Response.Message = {}));
    })(SendReminders400Response = Api.SendReminders400Response || (Api.SendReminders400Response = {}));
    /**
     * @export
     * @namespace SetCustomQuestions400Response
     */
    var SetCustomQuestions400Response;
    (function (SetCustomQuestions400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["SurveyLocked"] = "SurveyLocked";
                CodeEnum["SectionNotFound"] = "SectionNotFound";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = SetCustomQuestions400Response.Message || (SetCustomQuestions400Response.Message = {}));
    })(SetCustomQuestions400Response = Api.SetCustomQuestions400Response || (Api.SetCustomQuestions400Response = {}));
    /**
     * @export
     * @namespace SignInRequest
     */
    var SignInRequest;
    (function (SignInRequest) {
        /**
         * <p>When using <code>password</code>, you must provide the <code>username</code> and <code>password</code>.</p>
         * <p>When using <code>refresh_token</code> you must provide the <code>refresh_token</code>.</p>
         * <p>When using <code>client_credentials</code> you only need to provide the <code>client_id</code> and <code>client_secret</code>.</p>
         * <p>When using <code>token</code> you only need to provide the token in the <code>password</code>.</p>
         */
        var GrantTypeEnum;
        (function (GrantTypeEnum) {
            GrantTypeEnum["Password"] = "password";
            GrantTypeEnum["RefreshToken"] = "refresh_token";
            GrantTypeEnum["ClientCredentials"] = "client_credentials";
            GrantTypeEnum["Token"] = "token";
        })(GrantTypeEnum = SignInRequest.GrantTypeEnum || (SignInRequest.GrantTypeEnum = {}));
    })(SignInRequest = Api.SignInRequest || (Api.SignInRequest = {}));
    /**
     * @export
     * @namespace SignOutRequest
     */
    var SignOutRequest;
    (function (SignOutRequest) {
        /**
         * <p>The type of the token being supplied.</p>
         */
        var TokenTypeHintEnum;
        (function (TokenTypeHintEnum) {
            TokenTypeHintEnum["AccessToken"] = "access_token";
            TokenTypeHintEnum["RefreshToken"] = "refresh_token";
        })(TokenTypeHintEnum = SignOutRequest.TokenTypeHintEnum || (SignOutRequest.TokenTypeHintEnum = {}));
    })(SignOutRequest = Api.SignOutRequest || (Api.SignOutRequest = {}));
    var SortParticipants;
    (function (SortParticipants) {
        SortParticipants["GivenName"] = "givenName";
        SortParticipants["FamilyName"] = "familyName";
        SortParticipants["Email"] = "email";
        SortParticipants["Invited"] = "invited";
        SortParticipants["Completed"] = "completed";
    })(SortParticipants = Api.SortParticipants || (Api.SortParticipants = {}));
    var SortSurveys;
    (function (SortSurveys) {
        SortSurveys["Name"] = "name";
        SortSurveys["Type"] = "type";
        SortSurveys["Status"] = "status";
        SortSurveys["Modified"] = "modified";
        SortSurveys["ReportAvailable"] = "reportAvailable";
    })(SortSurveys = Api.SortSurveys || (Api.SortSurveys = {}));
    /**
     * @export
     * @namespace StartSurveyWithToken400Response
     */
    var StartSurveyWithToken400Response;
    (function (StartSurveyWithToken400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["SurveyNotFound"] = "SurveyNotFound";
                CodeEnum["SurveyNotAvailable"] = "SurveyNotAvailable";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = StartSurveyWithToken400Response.Message || (StartSurveyWithToken400Response.Message = {}));
    })(StartSurveyWithToken400Response = Api.StartSurveyWithToken400Response || (Api.StartSurveyWithToken400Response = {}));
    /**
     * @export
     * @namespace StartTotp400Response
     */
    var StartTotp400Response;
    (function (StartTotp400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["AlreadyHasTOTP"] = "AlreadyHasTOTP";
                CodeEnum["InvalidPassword"] = "InvalidPassword";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = StartTotp400Response.Message || (StartTotp400Response.Message = {}));
    })(StartTotp400Response = Api.StartTotp400Response || (Api.StartTotp400Response = {}));
    /**
     * @export
     * @namespace SurveyReportDataArea
     */
    var SurveyReportDataArea;
    (function (SurveyReportDataArea) {
        /**
         * @export
         * @namespace Series
         */
        var Series;
        (function (Series) {
            /**
             * <p>The style of graph to use.</p>
             */
            var StyleEnum;
            (function (StyleEnum) {
                StyleEnum["BARS"] = "BARS";
                StyleEnum["LINE"] = "LINE";
                StyleEnum["HIDE"] = "HIDE";
            })(StyleEnum = Series.StyleEnum || (Series.StyleEnum = {}));
        })(Series = SurveyReportDataArea.Series || (SurveyReportDataArea.Series = {}));
    })(SurveyReportDataArea = Api.SurveyReportDataArea || (Api.SurveyReportDataArea = {}));
    /**
     * @export
     * @namespace SurveySummary
     */
    var SurveySummary;
    (function (SurveySummary) {
        var StatusEnum;
        (function (StatusEnum) {
            StatusEnum["DRAFT"] = "DRAFT";
            StatusEnum["READY"] = "READY";
            StatusEnum["SCHEDULED"] = "SCHEDULED";
            StatusEnum["OPEN"] = "OPEN";
            StatusEnum["CLOSED"] = "CLOSED";
        })(StatusEnum = SurveySummary.StatusEnum || (SurveySummary.StatusEnum = {}));
    })(SurveySummary = Api.SurveySummary || (Api.SurveySummary = {}));
    /**
     * @export
     * @namespace UpdateCustomQuestion400Response
     */
    var UpdateCustomQuestion400Response;
    (function (UpdateCustomQuestion400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["SurveyLocked"] = "SurveyLocked";
                CodeEnum["UnsupportedQuestionType"] = "UnsupportedQuestionType";
                CodeEnum["QuestionLocked"] = "QuestionLocked";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = UpdateCustomQuestion400Response.Message || (UpdateCustomQuestion400Response.Message = {}));
    })(UpdateCustomQuestion400Response = Api.UpdateCustomQuestion400Response || (Api.UpdateCustomQuestion400Response = {}));
    /**
     * @export
     * @namespace UpdateMyDetails400Response
     */
    var UpdateMyDetails400Response;
    (function (UpdateMyDetails400Response) {
        /**
         * @export
         * @namespace Message
         */
        var Message;
        (function (Message) {
            var CodeEnum;
            (function (CodeEnum) {
                CodeEnum["ConfirmNewPasswordMismatch"] = "ConfirmNewPasswordMismatch";
                CodeEnum["CurrentPasswordMismatch"] = "CurrentPasswordMismatch";
                CodeEnum["WeakNewPassword"] = "WeakNewPassword";
                CodeEnum["Validation"] = "Validation";
            })(CodeEnum = Message.CodeEnum || (Message.CodeEnum = {}));
        })(Message = UpdateMyDetails400Response.Message || (UpdateMyDetails400Response.Message = {}));
    })(UpdateMyDetails400Response = Api.UpdateMyDetails400Response || (Api.UpdateMyDetails400Response = {}));
})(Api = exports.Api || (exports.Api = {}));
exports.AdminUserRole = Api.AdminUserRole;
exports.FilterSurveyParticipants = Api.FilterSurveyParticipants;
exports.FilterSurveys = Api.FilterSurveys;
/**
 * <p>determines question type, e.g. scale,</p>
 */
exports.QuestionTypeEnum = Api.QuestionTypeEnum;
exports.SortParticipants = Api.SortParticipants;
exports.SortSurveys = Api.SortSurveys;
